import { render, staticRenderFns } from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=template&id=1235b500&scoped=true"
import script from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js"
export * from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js"
import style0 from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=style&index=0&id=1235b500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235b500",
  null
  
)

export default component.exports